module.exports = "<p>\r\n  checkout-failed-page works!\r\n</p>\r\n"